/**
 * src/components/MoodSurvey.jsx
 * หลังทลายกำแพง → สำรวจอารมณ์ทันที
 */
import { memo, useState } from 'react';
import { MOODS } from '../constants/moods.js';
function MoodFace({ face, className = 'mood-face-svg' }) {
  if (face === 'angry') {
    return (
      <svg viewBox="0 0 40 40" className={className} aria-hidden="true">
        <circle cx="20" cy="20" r="18" fill="currentColor" />
        <path d="M12 14l6 3M28 14l-6 3" stroke="#1a0808" strokeWidth="2.2" strokeLinecap="round" />
        <path d="M13 28c2.5-3 11.5-3 14 0" stroke="#1a0808" strokeWidth="2.2" fill="none" strokeLinecap="round" />
      </svg>
    );
  }
  if (face === 'sad') {
    return (
      <svg viewBox="0 0 40 40" className={className} aria-hidden="true">
        <circle cx="20" cy="20" r="18" fill="currentColor" />
        <circle cx="14" cy="17" r="2" fill="#1a0808" />
        <circle cx="26" cy="17" r="2" fill="#1a0808" />
        <path d="M14 28c2-3 10-3 12 0" stroke="#1a0808" strokeWidth="2.2" fill="none" strokeLinecap="round" />
      </svg>
    );
  }
  if (face === 'neutral') {
    return (
      <svg viewBox="0 0 40 40" className={className} aria-hidden="true">
        <circle cx="20" cy="20" r="18" fill="currentColor" />
        <circle cx="14" cy="17" r="2" fill="#1a0808" />
        <circle cx="26" cy="17" r="2" fill="#1a0808" />
        <path d="M13 27h14" stroke="#1a0808" strokeWidth="2.2" fill="none" strokeLinecap="round" />
      </svg>
    );
  }
  if (face === 'smile') {
    return (
      <svg viewBox="0 0 40 40" className={className} aria-hidden="true">
        <circle cx="20" cy="20" r="18" fill="currentColor" />
        <circle cx="14" cy="17" r="2" fill="#1a0808" />
        <circle cx="26" cy="17" r="2" fill="#1a0808" />
        <path d="M13 24c2.5 4 11.5 4 14 0" stroke="#1a0808" strokeWidth="2.2" fill="none" strokeLinecap="round" />
      </svg>
    );
  }
  return (
    <svg viewBox="0 0 40 40" className={className} aria-hidden="true">
      <circle cx="20" cy="20" r="18" fill="currentColor" />
      <circle cx="14" cy="16" r="2.2" fill="#1a0808" />
      <circle cx="26" cy="16" r="2.2" fill="#1a0808" />
      <path d="M12 23c3 7 13 7 16 0" stroke="#1a0808" strokeWidth="2.2" fill="none" strokeLinecap="round" />
    </svg>
  );
}

function MoodSurveyInner({ wave = 1, returnLabel = 'กลับไปเล่นเกมเดิมพัน', onSelect, onContinue, onReturn }) {
  const [mood, setMood] = useState(null);
  const selected = MOODS.find((m) => m.id === mood) || null;
  const feelingBetter = mood != null && mood >= 4;
  const stillBad = mood != null && mood <= 2;

  return (
    <div className="mood-overlay" role="dialog" aria-modal="true" aria-labelledby="mood-title">
      <div className="mood-card mood-card--survey">
        <h2 id="mood-title" className="mood-title">
          ผ่านด่าน {wave} แล้ว
        </h2>
        <p className="mood-sub">ตอนนี้รู้สึกยังไง? เลือกอารมณ์ที่ตรงที่สุด</p>

        <div className="mood-scale" role="group" aria-label="ระดับอารมณ์">
          {MOODS.map((m) => (
            <button
              key={m.id}
              type="button"
              className={`mood-emoji${mood === m.id ? ' is-selected' : ''}`}
              style={{ color: m.color }}
              title={m.label}
              aria-label={m.label}
              aria-pressed={mood === m.id}
              onContextMenu={(e) => e.preventDefault()}
              onSelectStart={(e) => e.preventDefault()}
              onClick={() => {
                setMood(m.id);
                onSelect?.(m.id);
              }}
            >
              <span className="mood-tooltip ui-label" data-label={m.label} aria-hidden="true" />
              <MoodFace face={m.face} />
            </button>
          ))}
        </div>

        <p className={`mood-hint${selected?.hintClass ? ` ${selected.hintClass}` : ''}`}>
          {selected ? selected.hint : 'แตะหน้าเพื่อเลือกอารมณ์'}
        </p>

        <div className="mood-actions">
          {(mood == null || mood <= 3) && (
            <button
              type="button"
              className={`mood-btn mood-btn--continue${stillBad || mood === 3 ? ' is-primary' : ''}`}
              disabled={mood == null}
              onContextMenu={(e) => e.preventDefault()}
              onSelectStart={(e) => e.preventDefault()}
              onClick={() => onContinue?.(mood)}
            >
              <span className="ui-label" data-label="เล่นต่อ" aria-hidden="true" />
            </button>
          )}
          {(mood == null || mood >= 3) && (
            <button
              type="button"
              className={`mood-btn mood-btn--return${feelingBetter || mood === 3 ? ' is-primary' : ''}`}
              disabled={mood == null}
              onContextMenu={(e) => e.preventDefault()}
              onSelectStart={(e) => e.preventDefault()}
              onClick={() => onReturn?.(mood)}
            >
              <span className="ui-label" data-label={returnLabel} aria-hidden="true" />
            </button>
          )}
        </div>
      </div>
    </div>
  );
}

const MoodSurvey = memo(MoodSurveyInner);
export default MoodSurvey;
